import axios from "axios";
import { apiAddress } from "../settings";

class RugAPI {
  apiURL = apiAddress + "/rug/api/";

  // Get different parts of a rug
  // Part name must be provided
  // A List of parts containing name, id and image will be returned
  getPartsList(
    partType,
    brands = [],
    yarns = [],
    shanehs = [],
    densities = [],
    colors = [],
    limit = 20,
    offset = 0
  ) {
    let url = this.apiURL + "parts/new/?part_type=" + partType;
    if (brands.length > 0) {
      brands.forEach((brand) => (url += "&brands=" + brand));
    }
    if (yarns.length > 0) {
      yarns.forEach((yarn) => (url += "&yarns=" + yarn));
    }

    if (shanehs.length > 0) {
      shanehs.forEach((shaneh) => (url += "&shanehs=" + shaneh));
    }

    if (densities.length > 0) {
      densities.forEach((density) => (url += "&densities=" + density));
    }

    if (colors.length > 0) {
      colors.forEach((color) => (url += "&colors=" + color));
    }

    url += "&limit=" + limit;
    url += "&offset=" + offset;

    return axios
      .get(url)
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  // Get a list of rug types
  getTypesList() {
    return axios
      .get(this.apiURL + "types")
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  // Find a list of rugs matched to the rug with provided parts
  // rugType is the rug type id and it's required
  findRug(
    rugType,
    toranj = 0,
    corner = 0,
    tile = 0,
    background = 0,
    border = 0,
    pattern = 0
  ) {
    const url =
      this.apiURL +
      "find/?rug_type=" +
      rugType +
      "&toranj=" +
      toranj +
      "&corner=" +
      corner +
      "&tile=" +
      tile +
      "&background=" +
      background +
      "&border=" +
      border +
      "&pattern=" +
      pattern;
    return axios
      .get(url)
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  // Get user saved rugs.
  // User must be authenticated
  getUserRugs(userToken) {
    let headers = {
      Authorization: "Token " + userToken,
    };
    return axios({
      method: "get",
      url: this.apiURL + "user-rugs",
      headers: headers,
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error.response;
      });
  }

  // Get user rug data by rug ID
  // Only one rug data will be returned
  getUserRugDetails(userToken, rugID) {
    let headers = {
      Authorization: "Token " + userToken,
    };
    const url = this.apiURL + "user-rug/" + rugID;
    return axios({ method: "get", url: url, headers: headers })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error.response;
      });
  }

  getRugSellers(id, order = "", cities = []) {
    let url = this.apiURL + "rug/" + id + "/sellers?order=" + order;
    if (cities.length > 0) {
      cities.forEach((city) => {
        url += "&cities=" + city;
      });
    }
    return axios
      .get(url)
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  addLog(rugTypeID, partIds = []) {
    let log = new FormData();
    log.append("rug_type", rugTypeID);
    partIds.forEach((partId) => log.append("parts", partId));
    return axios
      .post(this.apiURL + "log/", log)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  getRugBrands() {
    return axios
      .get(this.apiURL + "brands/")
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  getRugYarns() {
    return axios
      .get(this.apiURL + "yarns/")
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  getRugColors() {
    return axios
      .get(this.apiURL + "colors/")
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  getRugCities(search = null) {
    let url = this.apiURL + "cities/";

    if (search) {
      url += "?q=" + search;
    }
    return axios
      .get(url)
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  getRugs(
    rugTypes = [],
    densities = [],
    shanehs = [],
    brands = [],
    yarns = [],
    colors = [],
    sizes = [],
    offset = 0,
    limit = 10
  ) {
    let url = this.apiURL + "rugs/?limit=" + limit + "&offset=" + offset + "&";

    rugTypes.forEach((rug) => (url += "rug_type=" + rug + "&"));
    densities.forEach((density) => (url += "densities=" + density + "&"));
    shanehs.forEach((shaneh) => (url += "shanehs=" + shaneh + "&"));
    brands.forEach((brand) => (url += "brands=" + brand + "&"));
    yarns.forEach((yarn) => (url += "yarns=" + yarn + "&"));
    colors.forEach((color) => (url += "colors=" + color + "&"));
    sizes.forEach((size) => (url += "sizes=" + size + "&"));
    return axios
      .get(url)
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }


  getRugSize() {
    let url = this.apiURL + "custom-rug/sizes/";
    return axios
      .get(url)
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }

  requestForRug(data) {
    let url = this.apiURL + "custom-rug/";

    return axios
      .post(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  requestForReplaceRug(data) {
    let url = this.apiURL + "rug-replacement/";
    return axios
      .post(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

export default RugAPI;
